import type { ReactNode } from "react";
import type { Appearance } from "@circle-react-shared/BuilderUI/Store/interfaceSlice";
import type { Themes } from "../Helpers/setCssVars";
import { useSetCssVars } from "../Hooks/useSetCssVars";
import { useSystemAppearance } from "../Hooks/useSystemAppearance";

export interface UserThemeManagerProps {
  appearance?: Appearance;
  children: ReactNode;
  shouldListenToSystemAppearance?: boolean;
  theme: Themes;
  toggleAppearance?: (newAppearance: Appearance) => void;
}

export const UserThemeManager = ({
  theme,
  children,
  shouldListenToSystemAppearance = false,
  appearance = "light",
  toggleAppearance,
}: UserThemeManagerProps) => {
  useSystemAppearance({
    onAppearanceChange: (newAppearance: Appearance) => {
      if (shouldListenToSystemAppearance) {
        toggleAppearance?.(newAppearance);
      }
    },
    isEnabled: shouldListenToSystemAppearance,
  });

  useSetCssVars({ themes: theme, appearance });

  return <>{children}</>;
};
